module.exports = "/_next/static/images/35b52c91d7fd0cd24dbba15cabfe1888-credit-card-prepayment@3x.png.webp";